// extracted by mini-css-extract-plugin
export default {"Snackbar":"Snackbar_Snackbar__wr-Ua","crossIcon":"Snackbar_crossIcon__3cyC0","desc":"Snackbar_desc__roLdg","Link":"Snackbar_Link__59kPz","information":"Snackbar_information__5EH1h"};